/** tempexp_14728-full-file */
import React, { FC } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { Download } from 'reactApp/ui/DataListItemCommonComponents/Download/Download';
import { ItemName } from 'reactApp/ui/DataListItemRow/components/ItemName/ItemName';
import { Pic } from 'reactApp/ui/DataListItemRow/components/Pic/Pic';
import { Size } from 'reactApp/ui/DataListItemRow/components/Size/Size';
import { TableColumn } from 'reactApp/ui/DataListItemRow/components/TableColumn/TableColumn';
import { ArchiveItemProps } from 'reactApp/ui/DataListItemRow/DataListItemRow.types';

interface ArchiveProps extends ArchiveItemProps {}

export const Archive: FC<ArchiveProps> = (props) => {
    return (
        <>
            <TableColumn>
                <Pic isFolder={props.isFolder} kind={props.kind} isVirus={false} ext={props.ext || ''} isPublic={props.isPublic} />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <ItemName
                    name={props.nameWithoutExt || props.name}
                    ext={props.ext || ''}
                    id={props.id}
                    isRenameAvailable={props.renameAvailable}
                />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                <Size size={props.size} />
            </TableColumn>
            <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                {!props.isFolder && !props.isEncrypted && (
                    <Download
                        onClick={props.onDownload}
                        ext={props.ext}
                        size={props.size}
                        id={props.id}
                        storage={props.storage}
                        viewType={EViewMode.list}
                    />
                )}
            </TableColumn>
        </>
    );
};
